export const PROMOTION_TYPE = {
    OVERRIDE_EXISTING_PRICE: 'OVERRIDE_EXISTING_PRICE',
    BUY_A_GET_B_FOR_FREE: 'BUY_A_GET_B_FOR_FREE',
    PWP: 'PWP',
    CASHBACK: 'CASHBACK',
    TAKE_AMOUNT_OFF: 'TAKE_AMOUNT_OFF',
    TAKE_PERCENTAGE_OFF: 'TAKE_PERCENTAGE_OFF',
    COMBO_SET_OR_PACKAGE_OR_BUNDLE: 'COMBO_SET_OR_PACKAGE_OR_BUNDLE',

    FREE_ITEM: 'FREE_ITEM',
    ZUS_BUNDLE: 'ZUS_BUNDLE',
};

export const PROMOTION_TYPE_VARIATION = {
    PRODUCT_OF_CATEGORY: 'PRODUCT_OF_CATEGORY',
    SPECIFIC_PRODUCTS: 'SPECIFIC_PRODUCTS',
};
export const APPLY_BEFORE = {
    ORDER_PLACED: 'ORDER_PLACED',
    ORDER_PAID: 'ORDER_PAID',
};

export const APPLY_DISCOUNT_PER = {
    ORDER_WHOLE: 'ORDER_WHOLE',
    ORDER: 'ORDER',
    ITEM: 'ITEM',
};

export const STORE_TYPE = {
    ONLINE: 'ONLINE',
    OFFLINE: 'OFFLINE',
};

export const APPLY_DISCOUNT_TYPE = {
    PROMOTION: 'PROMOTION',
    PROMOTION_PROMO_CODE: 'PROMOTION_PROMO_CODE',

    VOUCHER: 'VOUCHER',
};

export const CONDITION_TYPE = {
  AND: 'AND',
  OR: 'OR',
};
